const ip = window.location.hostname;
const protocol = window.location.protocol === "https:" ? "https" : "http";
const port = process.env.REACT_APP_BACKEND_PORT || "7001"; // fallback

export const IMAGE_URL =
  protocol === "http"
    ? `${protocol}://${ip}:${port}/`
    : `${protocol}://${ip}/images/`;

export const API_URL =
  protocol === "http"
    ? `${protocol}://${ip}:${port}/api`
    : `${protocol}://${ip}/api`;
